import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: "#202030",
      style: {"fill":"inherit"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FBFFFE",
      "fill-rule": "evenodd",
      d: "M11.675 14.17C9.153 14.17 7 14.552 7 16.078 7 17.605 9.14 18 11.675 18c2.521 0 4.674-.382 4.674-1.908s-2.139-1.922-4.674-1.922M11.675 11.993a2.996 2.996 0 1 0-2.997-2.997 2.986 2.986 0 0 0 2.976 2.996z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }